import React, { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Wrapper from './Wrapper';
import ExerciseFormContent, { defaultExerciseFormInitialValues } from './ExerciseFormContent';
import { useParams } from 'react-router';
import { UrlParams } from '../../../../shared/types';
import { useAppDispatch, useAppSelector } from '../../../../shared/hooks/useAppDispatch';
import { addBlock, addBlockType } from '../../../../shared/slices/blocks/api/blocks';
import StyledButtonGroup from './StyledButtonGroup';
import { Icons, Button } from 'src/modules/shared/components';
import { Dialog } from '@material-ui/core';

type Props = {
  seriesId: string;
};

const AddExerciseForm: FC<Props> = ({ seriesId }) => {
  const { bookId } = useParams<UrlParams>();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const error = useAppSelector((state) => state.blocks.error);
  const exercises = useAppSelector((state) => state.blocks.exercises);
  const handleSubmit = useCallback(
    (values: addBlockType['payload']) => {
      dispatch(
        addBlock({
          bookId: bookId!,
          pageId: seriesId,
          payload: {
            title: values.title,
            level: values.level,
            bloom_type: values.bloom_type,
            type: values.type,
            algebra_kit_exercise_id: values.algebra_kit_exercise_id,
            previous_block_id: exercises && exercises[exercises.length - 1]?.id,
            exercise_tool: values.exercise_tool === '1' ? null : values.exercise_tool,
            description: values.description ? values.description : '',
          },
          isExercisePage: true,
        })
      );
      setDialogOpen(false);
    },
    [dispatch, bookId, seriesId, exercises]
  );

  return (
    <Wrapper>
      <StyledButtonGroup>
        <Button icon={Icons.ADD_EXERCISES} onClick={() => setDialogOpen(true)}>
          {t('trajectory.sections.shared.addExerciseBtn')}
        </Button>
      </StyledButtonGroup>
      {dialogOpen && (
        <Dialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          aria-labelledby={'add-iframe-form'}
          fullWidth
        >
          <ExerciseFormContent
            mode="dialog"
            onSubmit={handleSubmit}
            onCancel={() => setDialogOpen(false)}
            error={error ? t('shared.errors.generic') : undefined}
            initialValues={defaultExerciseFormInitialValues}
          />
        </Dialog>
      )}
    </Wrapper>
  );
};

export default AddExerciseForm;
